<template>
  <div class="chat__image-wrapper">
    <div
      class="chat__avatar"
      :class="{ 'chat-preview__avatar-online': isContactIdOnline }"
      :style="{ backgroundImage: 'url(' + pic + ')' }"
    ></div>
  </div>
</template>

<script>
export default {
  props: ['pic', 'isContactIdOnline'],
};
</script>
